import { Frame } from "@shopify/polaris";
import { Logo } from "@shopify/polaris/build/ts/src/utilities/frame/types";
import React, { PropsWithChildren, useCallback, useContext, useState } from "react";
import { OverLayNavigation } from "src/components/custom/overlay/OverlayNavigation";
import { NavigationDesktop } from "src/components/shopify/NavigationDesktop";
import { TopBarMarkup } from "src/components/shopify/TopBarMarkup";
import { ContextUser } from "src/context/ContextUser";
import { useToggle } from "./ToggleProvider";

const logoSeller: Logo = {
  width: 124,
  topBarSource: "/seller.svg",
  url: "/",
  accessibilityLabel: "L192 Seller",
  contextualSaveBarSource: "/seller.svg",
};

const logoShipper: Logo = {
  width: 124,
  topBarSource: "/shipper.svg",
  url: "/",
  accessibilityLabel: "L192 Shipper",
  contextualSaveBarSource: "/shipper.svg",
};

export function FrameProvider(props: PropsWithChildren<unknown>) {
  const { merchant } = useContext(ContextUser);
  // const [open, setOpen] = useState(false);
  const { open, setOpen } = useToggle();
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const toggleMobileNavigationActive = useCallback(
    () => setMobileNavigationActive((mobileNavigationActive) => !mobileNavigationActive),
    [],
  );

  return (
    <Frame
      onNavigationDismiss={toggleMobileNavigationActive}
      showMobileNavigation={mobileNavigationActive}
      navigation={!!open ? <NavigationDesktop /> : null}
      topBar={
        <TopBarMarkup toggleMobileNavigationActive={toggleMobileNavigationActive} open={open} setOpen={setOpen} />
      }
      logo={merchant ? (merchant.role === "LOGISTIC_SHIPPER" ? logoShipper : logoSeller) : logoSeller}
    >
      {!open && <OverLayNavigation />}
      {props.children}
      {/* <div style={{ paddingLeft: !!open ? "0.5rem" : 0 }}>{props.children}</div> */}
    </Frame>
  );
}
